module.exports = __webpack_public_path__ + "static/desktop-map-c8a70eaa97ab0d54797e34cb6bbea370.webp";